var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
var SvgCrossIcon = function SvgCrossIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.763 12.003l7.856-7.857a1.247 1.247 0 00-1.36-2.045 1.25 1.25 0 00-.406.28l-7.856 7.856-7.856-7.856a1.248 1.248 0 00-1.765 1.765l7.856 7.857-7.856 7.856A1.247 1.247 0 003.256 22a1.25 1.25 0 00.885-.376l7.856-7.856 7.856 7.856a1.245 1.245 0 001.766 0 1.248 1.248 0 000-1.765l-7.856-7.856z",
    fill: "#000"
  })));
};
export default SvgCrossIcon;